require('./../../vendor/artestiq/magiq/Resources/assets/js/album');
require('./blogfilters');
require('./customers');
require('./faders');
require('./header');
require('./menu');
require('./numbers');
require('./projectfilters');
require('./projectsmap');
require('./scrolllinks');
require('./../../vendor/artestiq/magiq/Resources/assets/js/frontend/sliders');
require('./swipers');
require('./video');
